@if ({ gridApi: gridApiSubject | async }; as data) {
  <nz-tree
    #nzTreeComponent
    [nzData]="(nodes$ | async) || []"
    nzCheckable
    (nzCheckboxChange)="nzCheck($event, data.gridApi, nzTreeComponent)"
  ></nz-tree>
}
